import React from "react";
import styles from "./styles.module.scss";
import { MediaModel } from "app/models";
import { cls } from "app/utils";

interface IMulticamVideoBadgeProps {
  data: MediaModel;
  classNames?: string;
}

const MulticamVideoBadge = ({ data, classNames }: IMulticamVideoBadgeProps) => {
  return (
    data?.childResources?.length > 0 && (
      <div className={cls(styles.multicam_counter_overlay, classNames)}>
        <i className="ico ico-video-o" />
        {data?.childResources?.length + 1}
      </div>
    )
  );
};

export default MulticamVideoBadge;
